// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__DI9aM","with-quotation-marks":"Quote_with-quotation-marks__POQ_s","withQuotationMarks":"Quote_with-quotation-marks__POQ_s"};